<template>
   <v-theme-provider>
    <base-section
      id="news-latest"
      class="grey lighten-4 mt-n6"
      space="0"
    >
    <div 
      data-aos="fade-up"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-mirror="true"
      data-aos-once="true"
      data-aos-anchor-placement="top-center">
    <v-container
    >
    <base-section-heading title="#MantapBerhijrah" />
      <v-row
        no-gutters
      >
        <v-col
          v-for="item in items"
          :key="item.icon"
          cols="12"
          xs="12"
          md="4"
          sm="6"
        >
          <v-card
            outlined
            tile
            height = "130"
          >
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title><span><v-icon x-large color="fourth">{{item.icon}}</v-icon> <span class="body-1 font-weight-bold">{{item.title}}</span></span></v-card-title>
                <v-card-subtitle v-text="item.text"></v-card-subtitle>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
  </base-section>
</v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      items: [
        {
          icon: 'mdi-food-halal',
          title: 'Non Riba',
          text: 'Akad Wakalah dan Diawasi oleh DPS (Dewan Pengawas Syariah)',
          textcolor: 'white',
          align: 'start'
        },
        {
          icon: 'mdi-clock-fast',
          title: 'Proses Polis dan Klaim Cepat',
          text: 'Digital Proses',
          textcolor: 'white',
          align: 'center'
        },
        {
          icon: 'mdi-trophy',
          title: 'Asuransi Syariah Pertama dan Terbaik',
          text: 'dari Tahun 1995 dengan total lebih dari 28 penghargaan',
          textcolor: 'white',
          align: 'end'
        },
      ],
    }),
  }
</script>
